<script setup lang="ts">
import { ref } from "vue";

withDefaults(
  defineProps<{
    horizontal?: boolean;
    inline?: boolean;

    append?: boolean;
    prepend?: boolean;

    equalColumns?: boolean; // set all immediate children to be equal in size
    end?: boolean;
    start?: boolean;
    center?: boolean;

    justifyBetween?: boolean;

    full?: boolean;
    wrap?: boolean;

    noGap?: boolean;

    // Squezes the row-gap to 1
    squeeze?: boolean;
    gap?: string;
    gutter?: boolean;
  }>(),
  {
    inline: false,
    gap: "3",
  },
);
const root = ref<HTMLElement | null>(null);
defineExpose({ root });
</script>
<template>
  <div
    ref="root"
    class="m-layout-stack"
    :class="{
      flex: !inline,
      'inline-flex': inline,
      'flex-col': !horizontal,
      'equal-columns': equalColumns,
      'justify-end': end,
      'justify-start': start,
      'items-center': center,
      'flex-auto justify-between': justifyBetween,
      'flex-auto': full,
      'flex-nowrap': !wrap,
      [`gap-${gap}`]: !noGap,
      'row-gap-1': squeeze,
      gutter: gutter,
    }"
  >
    <div v-if="prepend" />
    <slot />
    <div v-if="append" />
  </div>
</template>
<style lang="scss" scoped>
.clinical-summary > {
  .m-layout-stack.equal-columns {
    > .m-layout-stack {
      flex: 1;
    }
  }
}

// Hard to target columns in columns in columns
.page-content .m-layout-stack {
  &.sm-columns {
    @media (max-width: 768px) {
      flex-direction: column;
      overflow: auto;
    }
  }
  //
  > .m-layout-stack {
    @media (max-width: 768px) {
      flex-direction: column;
    }

    .m-layout-stack {
      @media (max-width: 768px) {
        flex-direction: column;
      }
    }
  }
}

// the above is too broad so adding exclusions here
.slideover .slideover-content .m-layout-stack > .m-layout-stack,
.slideover .slideover-content .m-layout-stack > .m-layout-stack .m-layout-stack {
  @media (max-width: 505px) {
    flex-direction: row;
    justify-content: end;
  }
}

.modal-content .form-footer {
  .m-layout-stack {
    @media (max-width: 768px) {
      flex-direction: row;
    }
  }
}
.modal-content .form-content-wrapper:has(.m-section) .form-footer {
  .m-layout-stack {
    @media (max-width: 768px) {
      flex-direction: row;
      margin-left: var(--gap-4);
      margin-right: var(--gap-4);
    }
  }
}

// Optionally add this to the component where we want it responsive
// For buttons inside the encounter stack
.m-layout-stack-responsive {
  @media (max-width: 810px) {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
    justify-content: stretch;
  }
  > * {
    @media (max-width: 810px) {
      width: 100%;
    }

    @media (min-width: 810px) {
      flex: 0 0 auto;
      width: auto;
    }
  }
}
</style>
<style lang="scss">
.gutter {
  max-width: var(--page-content-max-width);
  margin-left: auto;
  margin-right: auto;
}
</style>
